import { createContext, useContext } from 'react';
import type { User } from '../types/User';
import type { City } from '../types/City';

interface AppContextType {
  loggedInUser: User | null;
  isLoggedIn: boolean;
  mobileDrawerOpen: boolean;
  login: (returnTo?: string) => void;
  logout: (returnTo?: string) => void;
  setMobileDrawerOpen: (open: boolean) => void;
  nearestCity: City | null;
  city: City | null;
}

const AppContext = createContext<AppContextType>({} as AppContextType);

export const useAppContext = () => useContext(AppContext);

export default AppContext;
